<template>
	<div id="JumpSellerListOrders" class="jumpSellerListOrders">
		<button @click="getAllJumpsellerOrdersLocalOption" ref="btnGetJumpSellerOrders" v-show="false"></button>
		<table class="table table-sm table-12 table-hover">
			<thead>
				<tr>
					<th class="text-center">ID</th>
					<th class="text-center">Completado</th>
					<th class="text-center">Cliente</th>
					<th class="text-center">Forma de Pago</th>
					<th class="text-center">
						<context-menu
							text="Pago"
							title="Click derecho para mas opciones"
							:list="listMenuPago"
							:multiSelect="false"
							:markSelection="true"
							defaultSelected="All"
							:localStorage="nameLocalStorage"
							@actionSelectItem="actionSelectMenuItemPagoLocal"
							@actionBlur="actionBlurMenuListPagoLocal"
							ref="contextMenuPaid"
							:saveSelection="true">
						</context-menu>
					</th>
					<th class="text-center">Despacho</th>
					<th class="text-center">Total</th>
					<th></th>
				</tr>
			</thead>
			<tbody v-if="!searchingJumpsellerOrders">
				<tr v-for="(item, index) in listJumpsellerOrders" :key="index">
					<td class="text-center"><a :href="'https://editorial-aces-chile.jumpseller.com/admin/cl/orders/edit/' + item.order.id" target="_blank">{{ item.order.id }}</a></td>
					<td>{{ item.order.completed_at }}</td>
					<td>{{ item.order.shipping_address.name }} {{ item.order.shipping_address.surname }}</td>
					<td>{{ item.order.payment_method_name }}</td>
					<td class="text-center"><span :class="classJumpsellerOrderStatus(item.order.status)" style="padding: 3px 10px;">{{ spanishJumpsellerOrderStatus(item.order.status) }}</span></td>
					<td class="text-center">{{ item.order.shipment_status }}</td>
					<td class="text-right">{{ methodFormatNumber(item.order.total) }}</td>
					<td><i class="fas fa-arrow-alt-circle-down pointer text-info" title="Confirmar" @click="selectOrder(item.order)"></i></td>
				</tr>
			</tbody>
			<tbody v-else>
				<tr>
					<td colspan="8" class="text-center">
						Buscando pedidos en la web . . .
						<img src="@/assets/search-color.gif" width="30px"/>
					</td>
				</tr>
			</tbody>
		</table>
		<div style="height: 50px">
			<button class="btn btn-link btn-sm" :disabled="searchingJumpsellerOrders || pageCurrent == 1" @click="changePageJumpsellerOrders(pageCurrent - 1)">< Anterior</button>
			<button class="btn btn-link btn-sm float-right" :disabled="searchingJumpsellerOrders || listJumpsellerOrders.length < qRowsJumpsellerOrder" @click="changePageJumpsellerOrders(pageCurrent + 1)">Siguiente ></button>
		</div>
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import jumpseller from '@/mixins/jumpseller'

import ContextMenu from '@/components/ContextMenu.vue'

export default {
	name: 'JumpSellerListOrders',
	mixins: [axiosAction, errors, mixin, jumpseller],
	data () {
		return {
			listMenuPago: [
				{ text: 'Pagado', id:'Paid', selected: false },
				{ text: 'Pendiente', id:'PendingPayment', selected: false },
				{ text: 'Cancelado', id:'Canceled', selected: false },
				{ text: 'Abandonado', id:'Abandoned', selected: false },
				{ text: 'Todo', id:'All', selected: false },
			],
			nameLocalStorage: 'paid'
		}
	},
	components: {
		'context-menu': ContextMenu
	},
	methods: {
		initModuleLocal() {
		},
		actionBlurMenuListPagoLocal(list) {
		},
		actionSelectMenuItemPagoLocal(item) {
			if(item.selected == true) {
				this.pageCurrent = 1
				this.getAllJumpsellerOrdersLocal(this.pageCurrent, item.value)
			}
		},
		getAllJumpsellerOrdersLocalOption(page) {
			this.pageCurrent = 1
			this.$refs.contextMenuPaid.$refs.btnEjecute.click()
		},
		changePageJumpsellerOrders(page) {
			this.pageCurrent = page
			let nameLocalStorage = this.$el.id + '-' + this.nameLocalStorage
			let paid = localStorage.getItem(nameLocalStorage)
			this.getAllJumpsellerOrdersLocal(this.pageCurrent, paid)
		},
		getAllJumpsellerOrdersLocal(page, status = 'All') {
			if(status == 'All') {
				this.getAllJumpsellerOrders(page)
			} else {
				this.getAllJumpsellerOrdersStatus(page, status)
			}
		},
		resultAxiosLocal(responseLocal, response) {
			this.$emit('hideLockScreen')
			switch(responseLocal) {
				case 'getAllJumpsellerOrdersResult': this.getAllJumpsellerOrdersResult(response); break;
		        default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
		},
		selectOrder(item) {
			this.$emit('actionSelectOrder', item)
		}
	},
	mounted () {
		this.initModule()
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
